import { Pagination } from "api/models/response/pagination";
import {
  createConditionalNaturalLanguageString,
  formatNumber,
} from "commons/ultilities";
import { flow, types } from "mobx-state-tree";
import { withRootStore } from "mobx-stores/_extension/with-root-store";

import { GetInpsectionNotes } from "api/models/request/inspection-note/inspection-note";

import { inspectionNoteBusiness } from "api/bussiness/inspection-note/inspection-note";
import {
  IInspectionNoteProperties,
  InspectionNote,
} from "mobx-stores/_models/inspection-note/inspection-note";
import { withSetPropAction } from "../_extension/with-set-props";
import { DateRangeFilterStore } from "./common/date-range-filter-store";
import { PaginationStore } from "./common/pagination-store";

export const InspectionNoteQueryParams = types
  .model({
    number: "",
    dateRangeFilter: types.optional(DateRangeFilterStore, {}),
    name: "",
    dealingName: "",
    barcode: "",
    code: "",
    isExactMatch: true,
  })
  .actions(withSetPropAction)
  .views((self) => ({
    get natureLanguageString() {
      const map = new Map<
        string,
        { label: string; value: string | number | null | undefined }
      >([
        ["number", { label: "số phiếu", value: self.number }],
        ["dealingName", { label: "tên giao dịch", value: self.dealingName }],
        ["name", { label: "tên hàng", value: self.name }],
        ["code", { label: "mã hàng", value: self.code }],
        ["barcode", { label: "mã barcode", value: self.barcode }],
      ]);

      return createConditionalNaturalLanguageString(map);
    },
  }));
export const InspectionNoteManagement = types
  .model({
    inspectionNotes: types.optional(types.array(InspectionNote), []),
    pagination: types.optional(PaginationStore, {}),
    queryParams: types.optional(InspectionNoteQueryParams, {}),
    searchConditionAsNaturalLanguage: "",
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({
    createSearchConditionAsNaturalLanguage() {
      const queryParamsAsNaturalLanguage =
        self.queryParams.natureLanguageString;
      return `${
        queryParamsAsNaturalLanguage ? `${queryParamsAsNaturalLanguage} - ` : ""
      }Tổng cộng: ${formatNumber(self.pagination.totalItems)} phiếu`;
    },
  }))
  .actions((self) => ({
    getInspectionNotes: flow(function* getInspectionNotes(
      request?: GetInpsectionNotes,
    ) {
      try {
        self._rootStore.setProp("inProgress", true);
        if (!request) {
          request = {
            filter: self.pagination.filter,
            maxResultCount: self.pagination.itemsPerPage,
            skipCount: self.pagination.skipCount,
            sorting: "",
            number: self.queryParams.number,
            dealingName: self.queryParams.dealingName,
            fromDate:
              self.queryParams.dateRangeFilter.fromAsDayJs?.isValid() &&
              self.queryParams.dateRangeFilter.from
                ? self.queryParams.dateRangeFilter.from
                : undefined,
            toDate:
              self.queryParams.dateRangeFilter.toAsDayJs?.isValid() &&
              self.queryParams.dateRangeFilter.to
                ? self.queryParams.dateRangeFilter.to
                : undefined,
            name: self.queryParams.name,
            code: self.queryParams.code,
            barcode: self.queryParams.barcode,
            isExactMatch: self.queryParams.isExactMatch,
          };
        }
        const res = (yield inspectionNoteBusiness.getLists(
          request,
        )) as Pagination<IInspectionNoteProperties>;
        self.setProp(
          "inspectionNotes",
          res.items?.map((x, i) => ({
            ...x,
            orderNumber:
              i + 1 + self.pagination.pageIndex * self.pagination.itemsPerPage,
          })),
        );
        self.pagination.setProp("totalItems", res.totalCount);
        self.setProp(
          "searchConditionAsNaturalLanguage",
          self.createSearchConditionAsNaturalLanguage(),
        );
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
  }));
